// Course search over OUR OWN course data — NO third-party API. Calls the
// ggCourseSearch Cloud Function (completetourneylive, us-central1), which searches
// the SAME bundled course DB the app ships (courses_db.json, ~14K NCRDB US courses)
// and returns { id, name, location, city, state, par, teeBoxes }. Because a picked
// course carries the SAME id + name an app-made game stores, the app resolves its
// yardages identically. Shared by the Hustler + PBCC sites and CourseSearchPicker.

import { httpsCallable } from 'firebase/functions'
import { memberFunctions } from './memberBackend.js'

// Per-hole pars + stroke index (handicap) from a raw API course. Reads the first
// tee that carries a full 18-hole `holes` array (pars/SI are the same across tees).
// Returns null when the course has no usable per-hole data. Retained for
// ggCourseLookup.test.js (the live mapping now happens server-side in the CF).
export function holesFromRawCourse(c) {
  for (const bucket of [c?.tees?.male || [], c?.tees?.female || []]) {
    for (const t of bucket) {
      const holes = Array.isArray(t?.holes) ? t.holes : []
      if (holes.length === 18) {
        const pars = holes.map((h) => Number(h?.par) || null)
        const strokeIndex = holes.map((h) => Number(h?.handicap) || null)
        if (pars.every((p) => p) && strokeIndex.every((s) => s)) return { pars, strokeIndex }
      }
    }
  }
  return null
}

/**
 * Search the course catalog by name via the ggCourseSearch Cloud Function.
 * Returns up to ~12 matches, each mapped to
 *   { id, name, location, par, teeBoxes, pars, strokeIndex }
 * (teeBoxes/pars/strokeIndex enriched server-side from the provider's details
 * endpoint). Short queries return [] without a call. THROWS on a failed call so
 * callers show a real "search unavailable" state instead of a silent empty list.
 */
export async function searchCourses(query) {
  const q = (query || '').trim()
  if (q.length < 3) return []
  const res = await httpsCallable(memberFunctions, 'ggCourseSearch')({ query: q })
  const courses = res?.data?.courses
  return Array.isArray(courses) ? courses : []
}
